module.exports = __webpack_public_path__ + "static/media/fun14.41fc221b.png";